import http from "../http-common";

class OrderService {
    getOrders(params) {
        return http.get("order/list", { params });
    }
    getOrderDetail(orderId) {
        return http.get("order/detail", { params: { orderId } });
    }
    updateOrderStatus(data) {
        return http.put("order/status", data);
    }
}

export default new OrderService();